import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {signInWithCustomToken} from "firebase/auth";
import {api} from "@/features/api";
import {auth} from "@/features/api";
import {clearAffiliateCode, getAffiliateCode} from "@/utils/affiliate-code";

interface SignByOTPCodeParams {
  email: string;
  code: string;
}

interface SignByOTPCodeResponse {
  customToken: string;
}

const useSignByOTPCode: () => UseMutationResult<
  void,
  Error,
  SignByOTPCodeParams
> = () =>
  useMutation({
    mutationFn: async ({email, code}: SignByOTPCodeParams) => {
      const affiliateCode = getAffiliateCode();

      const response = await api("TRENDARO_API_URL", false).post(
        `/users:signByOTPCode`,
        {
          json: {
            email,
            code,
            ...(affiliateCode ? {affiliateCode} : {}),
          },
        },
      );

      if (!response.ok) {
        const data = await response.json();

        if (response.status === 400) {
          throw new Error("Neplatný kód.");
        }

        throw new Error(
          `HTTP ${response.status} při ověřování OTP kódu. (${data?.error})`,
        );
      }

      // 200 OK - OTP verified, user logged in or created
      const data: SignByOTPCodeResponse = await response.json();

      try {
        // Sign in with the custom token from Firebase
        const userCredential = await signInWithCustomToken(
          auth,
          data.customToken,
        );

        if (!userCredential.user) {
          throw new Error("Chyba při přihlašování.");
        }
      } catch (error) {
        throw new Error(
          `Chyba při přihlašování: ${error instanceof Error ? error.message : "Unknown error"}`,
        );
      }
    },

    onSuccess: () => {
      clearAffiliateCode();
    },
  });

export default useSignByOTPCode;
